import type { ReactNode } from 'react'
import { useFileDrop } from './use-file-drop'
import styles from './decks.module.css'

export type SlotState = 'busy' | 'done' | 'bad'

type Props = {
  name: string
  label: ReactNode
  thumb?: string | null
  empty?: boolean
  pressed?: boolean
  state?: SlotState
  badge?: ReactNode
  dropDisabled: boolean
  ariaLabel: string
  onClick: () => void
  onFiles: (files: File[]) => void
  tools?: ReactNode
}

export function DropSlot({ name, label, thumb, empty, pressed, state, badge, dropDisabled, ariaLabel, onClick, onFiles, tools }: Props) {
  const drop = useFileDrop(onFiles, dropDisabled)
  return (
    <div className={`${styles.slot} ${empty ? styles.slotEmpty : ''}`} data-over={drop.over} data-state={state} {...drop.bind}>
      <button type="button" className={styles.slot} aria-pressed={pressed} aria-label={ariaLabel} onClick={onClick}>
        <span className={styles.slotImg} data-hint={empty ? 'Загрузить' : 'Заменить'}>
          {thumb ? <img src={thumb} alt="" loading="lazy" draggable={false} /> : label}
          {badge}
        </span>
        <span className={styles.slotName} title={name}>
          {name}
        </span>
      </button>
      {tools && <div className={styles.slotTools}>{tools}</div>}
    </div>
  )
}
